<template>
  <b-card header="Preview">
    <div class="preview-bg d-flex flex-column p-3">
      <b-row>
        <b-col>
          <b-img
            class="logo"
            src="/img/mlb-logo-text.png"
            alt="MLB" />
        </b-col>

        <b-col v-if="config.platformUrl">
          <div
            class="mt-3 mr-3 p-2"
            style="width: 450px; margin-left: auto; margin-right: 0; background-image: linear-gradient(to bottom, #272727, #111);">
            <b-row>
              <b-col
                class="text-right"
                cols="auto">
                <qrcode-vue :value="config.platformUrl" />
              </b-col>
              <b-col>
                <h4 style="font-weight: bolder">
                  View All Packages
                </h4>
                <p style="line-height: 1.3;">
                  To see more options like local in-market packages, scan the QR code or go to {{ config.platformUrl }}
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <header>
        {{ config.header || placeholder.header }}
      </header>

      <h5
        v-if="config.subheader"
        class="m-0"
        style="font-weight:lighter;">
        {{ config.subheader }}
      </h5>

      <b-form-group
        v-if="offerGroupOptions.length > 1"
        class="mt-3">
        <b-form-radio-group
          v-model="selectedOfferGroupIndex"
          :options="offerGroupOptions"
          buttons
          @change="onOfferGroupChange" />
      </b-form-group>

      <div class="carousel d-flex mt-3 p-0">
        <div
          v-for="(pkg, j) in enabledPkgs"
          :key="`${pkg.title}-${device}-${j}`">
          <div
            class="tile-wrap flex-column align-content-between ml-0 mr-3 p-0"
            :style="{width: packageWidth(pkg)}">
            <div
              v-if="pkg.tags && pkg.tags.length"
              class="mb-1 p-2 text-center"
              :style="{'background-color': pkg.tags[0].bgColor, 'color': pkg.tags[0].fgColor}">
              {{ pkg.tags[0].name }}
            </div>
            <div
              v-else
              class="mb-1 p-2">
              &nbsp;
            </div>
            <div class="p-3">
              <p
                class="p-0 font-weight-bold mb-1"
                style="font-size: 24px">
                {{ pkg.title || placeholder.title }}
              </p>
              <p
                v-if="pkg.subtitle"
                class="p-0 mt-2 mb-1"
                style="font-size: 14px">
                {{ pkg.subtitle }}
              </p>
              <span
                id="price"
                class="p-0"
                style="font-size: 30px; font-weight: bolder;">
                {{ pkg.price || placeholder.price }}
                <span
                  class="text-muted align-middle"
                  style="margin-left: -5px; font-size: 15px; font-weight: lighter;">
                  {{ pkg.priceUnit || "" }}
                </span>
              </span>
              <p
                id="text"
                class="p-0 mb-5">
                {{ pkg.text || placeholder.text }}
              </p>
              <div
                class="d-flex flex-column p-0"
                style="font-size: 18px;">
                <div
                  v-for="(button, i) in pkg.buttons"
                  :key="`${device}-${i}-btn`">
                  <div
                    v-if="button.enabled"
                    class="paywall-btn mb-2 pt-1 pb-1">
                    {{ button.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h6 class="mt-4">
        {{ config.footer }}
      </h6>
    </div>
  </b-card>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: "PaywallPreview",
  components: {
    QrcodeVue,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    device: {
      type: String,
      required: true,
    },
    offerGroupIndex: {
      type: Number,
      required: true,
    },
    placeholder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedOfferGroupIndex: this.offerGroupIndex,
    }
  },
  computed: {
    enabledPkgs() {
      // Checks if there are offer groups and returns an array of packages filtered by the enabled flag or an empty array if none found.
      return (this.config && this.config.offerGroups && this.config.offerGroups.length > this.offerGroupIndex) ?
        this.config.offerGroups[this.offerGroupIndex].packages.filter(pkg => pkg.enabled && pkg.buttons.filter(btn => btn.enabled)) : []
    },
    offerGroupOptions() {
      // Maps offer groups into radio button options with a name for the text and index for the value.
      return this.config.offerGroups && this.config.offerGroups.length ? this.config.offerGroups.map((og, index) => {
        return { text: og.name, value: index }
      }) : []
    },
  },
  watch: {
    offerGroupIndex(newVal) {
      // Update the local offer group index value when the prop value changes to enable two-way binding.
      this.selectedOfferGroupIndex = newVal
    },
  },
  methods: {
    onOfferGroupChange() {
      this.$emit('update:offerGroupIndex', this.selectedOfferGroupIndex)
    },
    packageWidth(pkg) {
      switch (pkg.size) {
        case "small":
          return "235px"
        case "large":
          return "400px"
        case "medium":
        default:
          return "365px"
      }
    },
  },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

.card-body, .container-fluid {
  font-family: "Roboto", sans-serif;
  color: white;
  padding: 0;
}

.card-body > .container-fluid, h4 {
  color: white;
}

.logo {
  margin-top: 30px;
  width: 200px;
  height: auto;
}

.preview-bg {
  margin: 0 auto;
  background: no-repeat url("//cd-images.mlbstatic.com/common/backgrounds/fhd/147-dark.jpg");
  background-size: cover;
  max-width: 1080px;
}

header {
  font-size: 30px;
  font-weight: bolder;
  letter-spacing: 1px;
  margin-top: 25px;
}

.tile-wrap {
  width: 325px;
  margin: 0 5px;
  font-size: 15px;
  border-radius: 8px;
  padding: 12px 12px 17px;
  background-image: linear-gradient(to bottom, #272727, #111);
  white-space: normal;
  display: inline-block;
}

.paywall-btn {
  letter-spacing: 1px;
  border-radius: 8px;
  text-align: center;
  border: solid 1.8px #888;
  box-shadow: 0 0 8px 0 #000;
}

.paywall-btn:hover {
  font-weight: bold;
  cursor: pointer;
  color: black;
  background-color: #ddd;
  transform: scale(1.07);
  transition: all 0.1s ease-in-out;
}

.carousel {
  overflow-x: scroll;
  white-space: nowrap;
}

</style>
